import { useSelector } from 'react-redux';
import { semesters } from 'keys';
import { isEmpty } from 'lodash';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { queryClient as qc } from 'keys'
import { getCategoriesFetch } from 'store/middlewares/assessment.crud';

export const statusOptions = [{ id: 1, status: "completed", name: "הסתיים" }, { id: 2, status: "undone", name: "לא בוצע" }, { id: 3, status: "redo", name: "לביצוע חוזר" }]

const useHeaderItems = () => {
    const queryClient = useQueryClient()
    const { grades } = useSelector(state => state.testTaker)
    const { assessmentFilters } = useSelector(state => state.assessment)

    const categories = useQuery({
        queryKey: [qc.categories],
        queryFn: async () => {
            const { data } = await getCategoriesFetch()
            return data
        },
        refetchOnWindowFocus: false
    })

    const headerItems = {
        year: {
            id: 1,
            placeholder: "שנה",
            options: [{ id: 2024, name: "2024" }, { id: 2025, name: "2025" }],
            name: "year",
            component: "autoComplete",
            width: 100
        },
        semester: {
            id: 2,
            placeholder: "סמסטר",
            options: semesters,
            name: "semester",
            component: "autoComplete",
            width: 180,
            disabled: assessmentFilters => isEmpty(assessmentFilters?.year) && isEmpty(assessmentFilters?.grade_of_allocation)
        },
        grade_of_allocation: {
            id: 1,
            placeholder: "שכבה בעת ביצוע",
            options: grades,
            name: "grade_of_allocation",
            component: "autoComplete",
            width: 100
        },
        category: {
            id: 0,
            placeholder: "סוג מבדק",
            options: categories.data,
            name: "category",
            component: "autoComplete",
            labelKey: "label",
            multiple: true,
        },
        assessment_def: {
            id: 3,
            placeholder: "מבדק",
            // options: queryClient.getQueryData(qc.assessmentDefs)?.data,
            name: "assessment_def",
            component: "autoComplete",
            multiple: true,
            width: 250
        },
        status: {
            id: 4,
            name: "status",
            placeholder: "סטטוס מבדק",
            component: "autoComplete",
            multiple: true,
            options: statusOptions
        }
    }

    return headerItems
}

export default useHeaderItems